export default __webpack_public_path__ + "static/media/ArrowUp.0122e11f.png";